import React, { useState } from 'react';
import { Box, Button, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CategoriesSeparationPage = ({ title, buttons, imagesCtopp, imagesTowre, imagesSummary }) => {
    const [currentCTOPPIndex, setCurrentCTOPPIndex] = useState(0);
    const [currentTOWREIndex, setCurrentTOWREIndex] = useState(0);
    const [currentSummaryIndex, setCurrentSummaryIndex] = useState(0);
    const [currentSelection, setCurrentSelection] = useState('CTOPP');

    const navigate = useNavigate();

    const onClick = (path) => {
        console.log(path);
        navigate(path);
    }

    const goToPrevious = () => {
        const isFirstImage = (currentIndex === 0);
        if (!isFirstImage) {
            const newIndex = currentIndex - 1;
            currentSelection === 'CTOPP' ? setCurrentCTOPPIndex(newIndex) : currentSelection === 'TOWRE' ? setCurrentTOWREIndex(newIndex) : setCurrentSummaryIndex(newIndex);
        }
    };
    
    const goToNext = () => {
        const isLastImage = (currentIndex === currentImages.length - 1);
        if (!isLastImage) {
            const newIndex = currentIndex + 1;
            currentSelection === 'CTOPP' ? setCurrentCTOPPIndex(newIndex) : currentSelection === 'TOWRE' ? setCurrentTOWREIndex(newIndex) : setCurrentSummaryIndex(newIndex);
        }
    };

    const handleSelectionChange = (event) => {
        setCurrentSelection(event.target.value);
    };

    const currentImages = currentSelection === 'CTOPP' ? imagesCtopp : currentSelection === 'TOWRE' ? imagesTowre : imagesSummary;
    const currentIndex = currentSelection === 'CTOPP' ? currentCTOPPIndex : currentSelection === 'TOWRE' ? currentTOWREIndex : currentSummaryIndex;

  return (
    <Box style={{ backgroundColor: '#F8F3EC' }} padding={4}>
        <Grid container mb={4}>
            <Grid item md={9}>
                <Typography variant="h5">{title}</Typography>
            </Grid>
            <Grid item md={3} style={{ display: 'flex', justifyContent: 'center' }}>
                <img src="Spark-Logo-sm.png" alt="Spark Interventions LLC" style={{ width: '25%', height: 'auto' }} />
            </Grid>
        </Grid>
        <Grid container>
            <Grid item xs={12} md={8} padding={4}>
                <Grid container direction="column" justifyContent="center" alignItems="center">
                    <Grid item style={{ padding: '2px' }}>
                        <Grid container direction="column" justifyContent="center" alignItems="center">
                            <Grid item>
                                <Typography variant="h6" sx={{textDecoration: 'underline'}} align="center">Individuals with the same profile have similar performance on the same test categories</Typography>
                            </Grid>
                            <Grid item>
                                <Typography component="div" variant="body1">
                                    <ul style={{ listStyle: 'inside' }}>
                                        <li style={{ textAlign: 'center' }}>This is a visualization of the model's operation and would not usually be seen by the end-user</li>
                                        <li style={{ textAlign: 'center' }}>The plots show performance on two test categories or profiles at a time</li>
                                        <li style={{ textAlign: 'center' }}>Individuals are dots, colored by predicted learning difference</li>
                                    </ul>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item alignItems="center" sx={{ mt: 4 }}>
                        {buttons.map((button, index) => (
                            <Button
                            key={index}
                            variant="contained"
                            color="primary"
                            onClick={() => onClick(button.path)}
                            style={{ margin: '0 8px' }}
                            >
                                {button.label}
                            </Button>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
                {currentImages.length > 0 && (
                    <Grid container direction="column" justifyContent="center" alignItems="center">
                        <Grid item>
                            <img key={currentIndex} src={`data:image/jpeg;base64,${currentImages[currentIndex]}`} alt={`Slide ${currentIndex}`} style={{ maxWidth: '100%'}} />
                        </Grid>
                        <Grid item>
                            <Grid container>
                                <Grid item>
                                    <Button
                                        key="Previous"
                                        variant="contained"
                                        color="primary"
                                        onClick={goToPrevious}
                                        style={{ margin: '0 8px' }}
                                        disabled={currentIndex === 0}
                                    >
                                        Previous
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        key="Next"
                                        variant="contained"
                                        color="primary"
                                        onClick={goToNext}
                                        style={{ margin: '0 8px' }}
                                        disabled={currentIndex === currentImages.length-1}
                                    >
                                        Next
                                    </Button>
                                </Grid>
                                <Grid item xs={12} alignContent="center" mt={2}>
                                    <RadioGroup aria-label="position" name="position" defaultValue="top" value={currentSelection} onChange={handleSelectionChange} style={{ alignContent: "center" }}>
                                        <FormControlLabel value="CTOPP" control={<Radio />} label="CTOPP" />
                                        <FormControlLabel value="TOWRE" control={<Radio />} label="TOWRE" />
                                        <FormControlLabel value="Summary" control={<Radio />} label="Summary" />
                                    </RadioGroup>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Grid>
    </Box>
  );
};

export default CategoriesSeparationPage;
